import React, { useRef } from 'react'
import HeroContainer from '../components/containers/HeroContainer'
import AboutContainer from '../components/containers/AboutContainer'

function HomeSection() {
  const homeRef = useRef(null)
  return (
    <section id="home" ref={homeRef}>
        <HeroContainer homeRef={homeRef}/>
        <AboutContainer/>
    </section>
  )
}

export default HomeSection